import _ from 'lodash';
import initialstate from '../../../../reducers/initialstate';
import * as types from '../../../../actions/actiontypes';

export default function oversightProjectsreducer(state = initialstate.oversightProjects, action) {
	switch (action.type) {
		case 'GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT':
			if (action.response) {
				return action.response || state;
			}
			return state;	
			case types.GET_OVERSIGHT_PROJECT_BY_PROJECTID:
				if (action.response) {
					let completedTaskCount = 0;
					let allTaskCount = 0;
					_.forEach(action.response, (counts) => {
						completedTaskCount = completedTaskCount + counts.allTC ;
						allTaskCount = allTaskCount + counts.allTTot ;
					});
					return {
						projectId: action.meta && action.meta.projectId,
						completedTaskCount: completedTaskCount,
						allTaskCount: allTaskCount
					};
				}
				return state;
			default:
				return state;
	}
}
